import * as placeReviewsAPI from "../api/place-reviews-api";
import { IPlaceReviewItem, IPlaceReviewsMeta } from "@/modules/place-module";

import { defineStore } from "pinia";
import { IPaginationResponse } from "@/package/global-types";
import { errorHandler } from "@/package/global-helpers/error-handler";

export const usePlaceReviewsStore = defineStore("place-reviews-store", {
  state: () => ({
    reviews: [] as Array<IPlaceReviewItem>,
    reviewsMeta: null as null | IPlaceReviewsMeta,
    reviewsPagination: null as null | IPaginationResponse,
    reviewsLoadingStatus: "loading" as "loading" | "loaded",
  }),

  actions: {
    async getPlaceReviews(
      placeId: number,
      params: { page: number; rating: Array<string> }
    ) {
      if (params.page === 1) {
        this.reviewsLoadingStatus = "loading";
      }

      try {
        const resp = await placeReviewsAPI.apiGetPlaceReviews(placeId, params);
        if (params.page === 1) {
          this.reviews = resp.data.data.reviews;
        } else {
          this.reviews = this.reviews?.concat(resp.data.data.reviews);
        }
        this.reviewsMeta = resp.data.data.reviews_meta;
        this.reviewsPagination = resp.data.data.pagination;
      } catch (error: Error | unknown) {
        errorHandler(error, true);
        throw error;
      } finally {
        this.reviewsLoadingStatus = "loaded";
      }
    },

    async blockUserLeaveFeedback() {
      if (this.reviewsMeta) {
        this.reviewsMeta.user_can_post_review = false;
      }
    },

    clearPlaceReviews() {
      this.reviews = [];
      this.reviewsMeta = null;
      this.reviewsPagination = null;
      this.reviewsLoadingStatus = "loading";
    },

    async leavePlaceFeedback(
      placeId: number,
      feedback: { rating: number; message: string }
    ) {
      try {
        await placeReviewsAPI.apiLeavePlaceFeedback(placeId, feedback);
      } catch (error: Error | unknown) {
        errorHandler(error, true);
        throw error;
      }
    },
  },
});
